import { Component } from '@angular/core';
import {
    AuthService,
    BlockAbstractComponent,
    ParserService,
    WindowService,
    Block,
    AnchorType,
    PageService,
} from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-block-anchor-list',
    templateUrl: './block-anchor-list.component.html',
    standalone: false,
})
export class BlockAnchorListComponent extends BlockAbstractComponent {
    static ANCHOR_BOX_TITLE?: string;
    mobileNavOpen: boolean = false;
    anchors!: AnchorType[];
    anchorBoxTitle: string = BlockAnchorListComponent.ANCHOR_BOX_TITLE ?? 'On this page';

    constructor(
        protected override auth: AuthService,
        protected override parser: ParserService,
        protected override pages: PageService,
        protected windowService: WindowService,
    ) {
        super(parser, auth);
    }

    override ngOnInit() {
        super.ngOnInit();

        this.getAnchors(this.pages.getCurrentPage().widgets ?? [], (this.anchors = []));
    }

    goToAnchor(anchor: AnchorType): void {
        this.toggleHamburger();
        const doc = this.windowService.document;
        const win = this.windowService.nativeWindow;

        if (!doc || !win) {
            return; // SSR → safely exit
        }

        // Try to get element by block id first
        let element = doc.getElementById('block--' + anchor.id);

        // If not found, try with name fallback
        if (!element && anchor.name) {
            const fallbackId = anchor.name
                .toLowerCase()
                .replace(/\s+/g, '-')
                .replace(/[^a-z0-9-]/g, '')
                .replace(/-+/g, '-');

            element = doc.getElementById(fallbackId);
        }

        if (element) {
            const header = doc.querySelector('header');
            const headerHeight = header ? (header as HTMLElement).offsetHeight : 120;
            const scrollPositionFromTop = headerHeight + 16;
            const pageYOffset = this.windowService.pageYOffset ?? 0;

            const elementPosition = element.getBoundingClientRect().top - scrollPositionFromTop + pageYOffset;

            this.windowService.scrollTo({
                top: elementPosition,
                behavior: 'smooth',
            });
        }
    }

    private getAnchors(blocks: Block[], anchors: AnchorType[]): void {
        blocks.forEach((block: Block) => {
            if (block.data.isAnchor && block.data.text) {
                const name = block.data.text.replace(/<[^>]*>/g, '');
                if (name && name.trim().length > 0) {
                    anchors.push({
                        id: block.id,
                        name: name,
                    } as AnchorType);
                }
            }

            this.getAnchors(block.content, anchors);
        });
    }

    toggleHamburger() {
        if (this.windowService.innerWidth <= 991) {
            if (this.mobileNavOpen) {
                return (this.mobileNavOpen = false);
            } else {
                return (this.mobileNavOpen = true);
            }
        } else {
            return false;
        }
    }
}
